module.exports = __webpack_public_path__ + "img/v2wallPaper2.ec8bd218.png";